<template>
  <div class="contact_container">
    <div class="intel_part01 contact_part01">
      <div>
        <p>业绩持续增涨，我们相遇，一起追求卓越</p>
        <button @click="showAboutDialog=true">立即试用</button>
      </div>
    </div>
    <div class="contact_part02">
      <div>
        <ul>
          <li class="customer_item">
            <h2>公司介绍</h2>
            <p>深圳市博商探寻企业咨询有限公司，专注于助力企业全要素销售能力，是打造卓越绩效销售团队的云服务商，其秉承「销售赋能，益企营」的理念，为企业提供高质量全流程业务场景闭环管理软件产品和信息化服务的专业公司。包括引流工具（直播 活动分享 众筹 ）、管理咨询（商学院）与企业全景运营框架销售工具（益企营）。
            </p>
          </li>
          <li class="customer_item">
            <h2>成长历史</h2>
            <p>益企营核心团队自2016年起即专事于企业信息化领域，公司骨干员工多具有在国内外知名企业从业和服务的经历，有着深厚的技术和经验积累，具备为各类企业用户提供高质量全流程业务场景信息化产品和解决方案的能力。
            </p>
            <p>多年来公司坚持自主创新，不断改进产品质量及服务水平，公司所有产品及核心技术均为自主研发，拥有独立知识产权（软件著作权登记号：2018SR109083、2018SR1090238、2018SR1090851、2018SR1090245、2018SR495615、2018SR495597、2016SR338813、2017SR595103、2017SR595619、2017SR595292、2017SR266531、2017SR266529、2018SR700162、2018SR852050、2018SR947219、2018SR950417），在软件研发方面有着显著的技术优势。
            </p>
          </li>
          <li class="customer_item customer_item_us">
            <h2>联系方式</h2>
            <div>
              <div id="map">
                <baidu-map class="map" :center="{lng:113.894842,lat:22.507334}" :zoom="15" :scroll-wheel-zoom="true"><!--:scroll-wheel-zoom="true" :mapStyle="mapStyle"-->
                  <bm-marker :position="{lng:113.894842,lat:22.507334}" :dragging="true">
                    <bm-label content="博商管理科学研究院" :labelStyle="{color: '#333', fontSize : '12px',border:'1px solid #ddd',borderRadius:'3px'}" :offset="{width: -16, height: 30}"/>
                  </bm-marker>
                </baidu-map>
              </div>
              <div class="aboutUs">
                <p>深圳市博商探寻企业咨询有限公司</p>
                <ul>
                  <li>服务热线：0755-86681611</li>
                  <li>客服经理：18948329683</li>
                  <li>企业地址：深圳市前海深港合作区妈湾十九单元03街坊信利康大厦17F</li>
                  <li>邮政编码：830011</li>
                  <li>客服邮箱：XIEYINGZHAO@BOSUM.COM</li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <my-dialog :show-dialog.sync="showAboutDialog"></my-dialog>
  </div>
</template>

<script>
  import myDialog from '../components/my-dialog'
  export default {
    data () {
      return {
        showAboutDialog:false,
      }
    },
    components:{myDialog}
  }
</script>





// WEBPACK FOOTER //
// src/components/contactUs.vue